var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3RollingDoorGarageOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 33v32h40V33H36zm36 28H40V51h32v10zm0-14H40v-3h32v3zm0-7H40v-3h32v3zm-48 8h8v4H0V22.11L21 7.28l21 14.66V29h-4v-5.09L21 12.25l-17 12V48h14v-9h6v9zm2-21h6v6h-6v-6zm-16 6v-6h6v6h-6z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Rolling_door_garage_open.f29db108.svg";
export { SvgE3RollingDoorGarageOpen as ReactComponent };